import { setCurrentStorefront } from "@@/store-fronts/shared/current-store-front";
import { VoucherStoreFront } from "@@/store-fronts/vouchers/voucher-store-front";

const VouchersPage = () => {
    setCurrentStorefront("vouchers");
    return <VoucherStoreFront key="voucher-store-front" />;
};

export { VouchersPage };
